module.exports = __webpack_public_path__ + "static/media/snipe book.cc40f208.png";